import styled, { css } from 'styled-components';
import { remCalc } from '@lux/helpers';
import { withTheme } from '../../core/ThemeProvider';
import Grid from '../Grid';
import Row from '../Row';
import Text from '../Text';
export var FooterGrid = withTheme(styled(Grid).withConfig({
  displayName: "style__FooterGrid",
  componentId: "sc-1u7mrin-0"
})(function (props) {
  return css(["&&{background-color:", ";padding-top:0;padding-bottom:0;}"], props.coreTheme.footer.backgroundColor);
}));
export var FooterPagesRow = withTheme(styled(Row).withConfig({
  displayName: "style__FooterPagesRow",
  componentId: "sc-1u7mrin-1"
})(function (props) {
  return css(["margin-top:", ";margin-bottom:", ";display:none;@media (min-width:", "){display:flex;}"], remCalc(40), remCalc(40), props.coreTheme.brk_md);
}));
export var HeadingAnchor = withTheme(styled(Text).withConfig({
  displayName: "style__HeadingAnchor",
  componentId: "sc-1u7mrin-2"
})(function (props) {
  return css(["display:block;font-family:", ";font-size:", ";color:", ";margin-bottom:", ";"], props.coreTheme.footer.footerPage.headingFont, props.coreTheme.footer.footerPage.headingFontSize, props.coreTheme.footer.footerPage.headingFontColor, remCalc(10));
}));
export var FooterPage = styled.div.withConfig({
  displayName: "style__FooterPage",
  componentId: "sc-1u7mrin-3"
})(["margin-bottom:", ";"], remCalc(10));
export var FooterPageAnchor = withTheme(styled(Text).withConfig({
  displayName: "style__FooterPageAnchor",
  componentId: "sc-1u7mrin-4"
})(function (props) {
  return css(["display:block;font-family:", ";font-size:", ";color:", ";"], props.coreTheme.footer.footerPage.itemFont, props.coreTheme.footer.footerPage.itemFontSize, props.coreTheme.footer.footerPage.itemFontColor);
}));
export var FooterLinksRow = styled(Row).withConfig({
  displayName: "style__FooterLinksRow",
  componentId: "sc-1u7mrin-5"
})(["margin-top:", ";margin-bottom:", ";"], remCalc(40), remCalc(40));
export var Divider = withTheme(styled.hr.withConfig({
  displayName: "style__Divider",
  componentId: "sc-1u7mrin-6"
})(function (props) {
  return css(["display:none;border:none;border-bottom:", ";@media (min-width:", "){display:block;}"], props.coreTheme.footer.dividerBorder, props.coreTheme.brk_xs);
}));
export var FlexGrid = withTheme(styled.div.withConfig({
  displayName: "style__FlexGrid",
  componentId: "sc-1u7mrin-7"
})(function (props) {
  return css(["display:flex;flex-direction:column;@media (min-width:", "){flex-direction:row;}"], props.coreTheme.brk_xs);
}));
export var Navigation = withTheme(styled.nav.withConfig({
  displayName: "style__Navigation",
  componentId: "sc-1u7mrin-8"
})(function (props) {
  return css(["list-style:none;padding:0;margin:0;display:flex;flex-wrap:wrap;flex:1 1 auto;flex-direction:column;@media (min-width:", "){flex-direction:row;}"], props.coreTheme.brk_xs);
}));
export var Anchor = withTheme(styled(Text).withConfig({
  displayName: "style__Anchor",
  componentId: "sc-1u7mrin-9"
})(function (props) {
  return css(["display:block;font-family:", ";color:", ";font-size:", ";flex:1 1 auto;text-align:center;margin-bottom:", ";@media (min-width:", "){flex:0 1 auto;margin-right:", ";text-align:left;margin-bottom:0;}"], props.coreTheme.footer.linkFont, props.coreTheme.footer.linkFontColor, props.coreTheme.footer.linkFontSize, remCalc(20), props.coreTheme.brk_xs, remCalc(22));
}));
export var Copyright = withTheme(styled.div.withConfig({
  displayName: "style__Copyright",
  componentId: "sc-1u7mrin-10"
})(function (props) {
  return css(["font-family:", ";font-size:", ";color:", ";flex:1 1 auto;text-align:center;@media (min-width:", "){text-align:right;margin-left:", ";}"], props.coreTheme.footer.copyRightFont, props.coreTheme.footer.copyRightFontSize, props.coreTheme.footer.copyRightFontColor, props.coreTheme.brk_xs, remCalc(16));
}));
export var Social = withTheme(styled.div.withConfig({
  displayName: "style__Social",
  componentId: "sc-1u7mrin-11"
})(function (props) {
  return css(["margin-bottom:", ";text-align:center;@media (min-width:", "){text-align:right;}"], remCalc(10), props.coreTheme.brk_xs);
}));
export var SocialLink = withTheme(styled.a.withConfig({
  displayName: "style__SocialLink",
  componentId: "sc-1u7mrin-12"
})(function (props) {
  return css(["display:inline-block;margin:0 ", ";@media (min-width:", "){margin:0 0 0 ", ";}"], remCalc(15), props.coreTheme.brk_xs, remCalc(10));
}));
export var SocialIcon = styled.img.withConfig({
  displayName: "style__SocialIcon",
  componentId: "sc-1u7mrin-13"
})(["margin:0;height:", ";"], remCalc(30));
export var FooterText = withTheme(styled.span.withConfig({
  displayName: "style__FooterText",
  componentId: "sc-1u7mrin-14"
})(function (props) {
  return css(["display:block;font-weight:normal;font-size:", ";font-family:", ";color:", ";letter-spacing:", ";line-height:1.5;text-align:center;@media (min-width:", "){text-align:left;}"], props.coreTheme.footer.footerTextFontSize, props.coreTheme.footer.footerTextFont, props.coreTheme.footer.footerTextFontColor, props.coreTheme.footer.footerTextFontSpacing, props.coreTheme.brk_xs);
}));